import React from "react";
import styled from "styled-components";
import { Modal } from "antd";
import iconHeader from "../../../../assets/images/Event-2025/icon-popup-header.png";
import iconClose from "../../../../assets/images/Event-2025/icon-btn-close-popup.png";
import iconSnowFooter from "../../../../assets/images/Event-2025/icon-popup-snow-footer.png";
import bg from "../../../../assets/images/Event-2025/icon-popup-bg.png";
import btnAction from "../../../../assets/images/Event-2025/btn-action-popup.png";
import TextGradient from "@pages/Events/NewYearAndChristmas_2025/components/TextGradient";
// import PATH from "../../../../config/PATH";
import { useHistory } from "react-router";
// import { urlPageBid } from "../../../../helper/const";
import { useTranslation } from "react-i18next";

export default function PopupTopAward({
  open,
  setOpen = () => {},
  isGetContainer = false,
  data = {},
  wrapClassName = "",
  isPageNewYear,
  isAwar,
  handleActionHidden = () => {},
  isCodeWin
}) {
  const { t } = useTranslation();
  const history = useHistory();
  const handleCancel = () => {
    setOpen(false);
    handleActionHidden();
  };

  const {
    imgMain,
    imgLeft,
    imgRight,
    contentHeader,
    descriptionHeader,
    descriptionFooter,
    isFailsAll = false,
    contentAction,
    action = () => {},
    widthError,
    strokeWidth,
  } = data;

  const onAfterOpen = (open) => {
    if (!wrapClassName || !open) {
      return null;
    }

    const zIndexElement = document.querySelector(`.${wrapClassName}`);

    if (zIndexElement) {
      const modalRoot = zIndexElement.closest(".ant-modal-root");

      if (modalRoot) {
        const modalMask = modalRoot.querySelector(".ant-modal-mask");

        if (modalMask) {
          modalMask.classList.add("z-index-1002");
        }
      }
    }
  };

  return (
    <StyleModal
      centered
      visible={open}
      onOk={handleCancel}
      onCancel={handleCancel}
      closable={false}
      wrapClassName={wrapClassName || ""}
      afterOpenChange={onAfterOpen}
      getContainer={isGetContainer ? false : ""}
    >
      <div
        className={`position-relative ${
          isPageNewYear ? "new-year-popup-container" : ""
        } ${isAwar ? "awar" : ""}`}
      >
        <img src={bg} alt="" className="bg-popup" />
        <img
          src={iconClose}
          alt=""
          className="icon-close"
          onClick={handleCancel}
        />
        <div className="header-container-popup">
          <img src={iconHeader} alt="" className="icon-header-popup" />
          <div className="content-header">
            <TextGradient
              title={contentHeader || "OOPS!"}
              stop={[
                { offset: "0%", color: "#FFFFFF" },
                { offset: "36%", color: "#ffffff" },
                { offset: "65%", color: "#ceb084" },
                { offset: "100%", color: "#C9913B" },
              ]}
              fontSize="28"
              height={45}
              stroke="#7F0E1B"
              isCenterItem
              strokeWidth={strokeWidth}
            />
          </div>
        </div>

        <div className="body-popup">
          <div className="main-body">
            <div className={`main-content ${isCodeWin ? "fz-16" : ""}`}>{descriptionHeader || ""}</div>
          </div>
          <div className="icon-main-popup">
            <img src={imgLeft} alt="" className="icon-ng" />
            <img src={imgRight} alt="" className="icon-th" />
            <img
              src={imgMain}
              alt=""
              className={`icon-error ${isFailsAll ? "icon-error-full" : ""} ${
                widthError ? "width-165px" : ""
              }`}
            />
          </div>
          <div className="main-footer">
            <img src={iconSnowFooter} alt="" className="icon-snow-footer" />
          </div>
          {isFailsAll ? (
            <>
              <div className="container-action">
                <div
                  className="content-footer"
                  style={{ paddingBottom: "15px" }}
                >
                  {descriptionFooter || ""}
                </div>
                <div className="error-number">
                  <div
                    className="position-relative container-action-main"
                    // onClick={() =>
                    //   navigate(`${PATH.BID}/${urlPageBid.running}`)
                    // }
                  >
                    <img
                      src={btnAction}
                      alt=""
                      className="btn-container-action"
                    />
                    <div className="content-action">
                      {t("event_new_year.bid_now")}
                    </div>
                  </div>
                  <div
                    className="position-relative container-action-main"
                    // onClick={() => navigate(PATH.PACKAGE)}
                  >
                    <img
                      src={btnAction}
                      alt=""
                      className="btn-container-action"
                    />
                    <div className="content-action">
                      {t("event_new_year.buy_packages")}
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="container-action">
              <div className="content-footer">{descriptionFooter || ""}</div>
              <div
                className="position-relative container-action-main"
                onClick={action}
              >
                <img src={btnAction} alt="" className="btn-container-action" />
                <div className="content-action">{contentAction}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </StyleModal>
  );
}

const StyleModal = styled(Modal)`
  .error-number {
    display: flex;
    width: 90%;
    margin: 0 auto;
    gap: 20px;
  }

  .icon-error-full {
    width: 255px !important;
  }

  .content-footer {
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    width: 90%;
    margin: 0 auto;
    padding-bottom: 15px;
    line-height: 18px;
  }

  .icon-main-popup img {
    position: absolute;
    bottom: 0;
    z-index: 10;
    pointer-events: none;
  }

  .icon-main-popup {
    .icon-ng,
    .icon-th {
      bottom: 140px;
    }

    .icon-ng {
      left: 0;
    }

    .icon-th {
      right: -60px;
    }
  }

  .icon-main-popup .icon-error {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
  }

  .content-action {
    position: absolute;
    left: 50%;
    top: calc(50% - 3px);
    transform: translate(-50%, -50%);
    font-size: 18px;
    color: white;
    width: 100%;
    font-weight: bold;
    filter: drop-shadow(1px 1px 1px rgba(199, 98, 22, 1))
      drop-shadow(-1px 0 0 rgba(199, 98, 22, 1))
      drop-shadow(0 1px 0 rgba(199, 98, 22, 1))
      drop-shadow(0 -1px 0 rgba(199, 98, 22, 1));
  }

  .container-action {
    bottom: 10px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9;
    width: 100%;
  }

  .btn-container-action,
  .container-action-main {
    height: 58px;
  }

  .container-action-main {
    cursor: pointer;
    width: max-content;
    margin: 0 auto;
  }

  .bg-popup {
    border-radius: 30px;
    overflow: hidden;
    height: 100%;
  }

  .body-popup {
    border-radius: 30px;
    border: 4px solid #9b0a0a;
    overflow: hidden;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }

  .main-footer {
    width: 100%;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    height: 100%;
    pointer-events: none;
  }

  .icon-snow-footer {
    bottom: 0;
    left: 0;
    height: 100%;
  }

  .main-content {
    filter: drop-shadow(1px 0 0 #2e2b2b) drop-shadow(-1px 0 0 #2e2b2b)
      drop-shadow(0 1px 0 #2e2b2b) drop-shadow(0 -1px 0 #2e2b2b);
    color: white;
    width: 100%;
    padding-top: 100px;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 18px;
    line-height: 1.6;
    font-weight: 500;
  }

  .fz-16{
    font-size: 16px;
  }

  .content-forcus {
    color: #f1e884;
  }

  .icon-close {
    position: absolute;
    right: -12px;
    z-index: 9;
    top: -12px;
    width: 42px;
    cursor: pointer;
  }

  .header-container-popup {
    position: absolute;
    top: -50px;
    left: 50%;
    transform: translateX(-50%);
    max-width: calc(100% + 40px);
    width: calc(100% + 40px);
    z-index: 2;
  }

  .content-header {
    position: absolute;
    z-index: 2;
    color: white;
    top: 17px;
    left: 50%;
    transform: translateX(-50%);
  }

  .main-body {
    position: absolute;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
  }

  .btn-close-popup-event {
    color: white;
    font-size: 20px;
    position: absolute;
    z-index: 2;
    right: 10px;
    top: 3px;
    cursor: pointer;
  }

  .position-relative {
    position: relative;
  }

  .position-absolute {
    position: absolute;
  }

  .ant-modal-content {
    background-color: inherit !important;
    box-shadow: inherit !important;
    padding: 0 !important;
  }

  .ant-modal-footer {
    display: none;
  }

  .ant-modal-body {
    text-align: center;
    display: flex;
    justify-content: center;
    padding-top: 30px;
  }

  .ant-modal-close {
    right: 40px !important;

    svg {
      color: white;
    }
  }

  .icon-main-popup .width-270px {
    width: 270px;
  }

  @media (min-width: 992px) {
    .icon-close,
    .container-action-main {
      &:hover {
        scale: 1.05;
        transition: 0.3s ease-in-out;
      }
    }
  }

  @media (max-width: 768px) {
  }

  @media (max-width: 576px) {
    .header-container-popup {
      max-width: calc(100% + 10px);
      width: calc(100% + 10px);
    }

    .icon-close {
      width: 36px;
      right: 5px;
    }

    .content-header {
      top: 20px;
    }

    .main-content {
      padding-top: 60px;
      padding-left: 15px;
      padding-right: 15px;
      font-size: 16px;
      line-height: 1.4;
      font-weight: 500;
    }

    .icon-ng {
      width: 120px;
    }

    .icon-main-popup .icon-ng,
    .icon-main-popup .icon-th {
      bottom: 130px;
    }

    .icon-main-popup .icon-error {
      width: 160px;
    }

    .icon-main-popup .width-270px {
      width: 250px;
    }

    .btn-container-action,
    .container-action-main {
      height: 50px;
      width: 180px;
    }

    .content-action {
      font-size: 16px;
    }

    .content-footer {
      padding-bottom: 25px;
      font-size: 13px;
    }

    .icon-error-full {
      width: 180px !important;
    }

    .new-year-popup-container {
      .content-action {
        font-size: 12px;
      }

      .error-number{
        gap: 12px;
      }
    }
  }

  @media (max-width: 430px) {
    .content-header {
      top: 16px;
    }

    .awar .content-footer{
      font-size: 11px;
      width: 95%;
      padding-bottom: 7px;
      line-height: 14px;
    }

    .container-action {
      bottom: 6px;
      z-index: 11;
    }

    .btn-container-action {
      height: 40px;
    }
    
    .container-action-main {
      height: 40px;
      width: auto;
    }

    .icon-main-popup .icon-ng,
    .icon-main-popup .icon-th {
      bottom: 110px;
    }

    .icon-ng {
      width: 100px;
    }

    .icon-th {
      height: 160px;
    }

       .main-content {
        padding-top: 40px;
        padding-left: 15px;
        padding-right: 15px;
        font-size: 14px;
        line-height: 18px;
        font-weight: 500;
    }

     .content-header {
        top: 3px;

        text {
          font-size: 20px;
        }
    }
  }
`;
